jQuery(function() { 
    $(".input").on('change', function () {
        if ($(this).val().length !== '') {
            $(this).parents(".input-wrapper").addClass("hasValue");
        }
    });

    $(".response-msg-icon").on('click', function () {
        $(".response-msg").slideUp(300);
        $(".resend-response-msg").slideUp(300);
    });


    $("#info-form, #cart-info-form, #add-company").validate({
        onkeyup: false,
        onclick: false,
        onfocusout: false,
        rules: {
            fname: {
                required: true
            },
            lname: {
                required: true
            },
            company: {
                required: true
            },
            country: {
                required: true
            },
        },

        messages: {
            fname: {
                required: fname_error_msg
            },
            lname: {
                required: lname_error_msg
            },
            company: {
                required: company_error_msg
            },
            country: {
                required: country_error_msg
            },
            CompanySize: {
                required: company_size_error_msg
            }
        }
    });

    $("#info-form, #add-company, #cart-info-form").on("keyup, change", function(e){
        var errorId = e.target.id + '-error';
        if (e.target.value.length > 0) {
            $('#'+ errorId).hide();
            e.target.classList.remove("error");
        }
        else{
            if ($('#'+ errorId).length) {
                $('#'+ errorId).show();
                e.target.classList.add("error");
            }
        }
    });

    $("#info-form").on('submit', (function (e) {
        if ($(this).valid()) {
            e.preventDefault();
            const el= this;
            $(".modal").css("display","block");
            var trialDays = "30";
            var formData = {
                "email":$('#email').val(),
                "firstName":$('#fname').val(),
                "lastName":$('#lname').val(),
                "country":$('#country').val(),
                "companyName":$('#company').val(),
                "hasUserAcceptedPrivacyPolicy": true,
                "hasUserAcceptedMarketingConsent": $('#consent').is(":checked"),
                "isAutoTrialCustomer": true,
                "inventories": "enterprise,mtf 100k addendum",
                "TrialDays": trialDays,
                "CompanySize":$('#CompanySize').val()
            }
            var authToken ="Bearer " + atob($('#token').val());
            $.ajax({
                type: "POST",
                url: "https://enterprise.monotype.com/en/admin/customer",
                headers: {
                    'Authorization': authToken,
                    'Content-Type':'application/json'
                },
                data: JSON.stringify(formData),
                success: function (msg) {
                    el.setAttribute('data-custom-event', 'freeTrialSuccess');
                    dispatchCustomEvent(el, {linkCategory: 'trial form ', linkSection:'Add company form', linkName:'successful trial start', linkType:'button'})
                    if (getCookie("agency_user_data") != ''){
                        deleteCookie("agency_user_data");
                    }
                    if (getCookie("continue_agency_journey") != ''){
                        deleteCookie('continue_agency_journey');
                    }
                    window.location.href = redirect_url.replace('&orgId=[orgId]','');
                },
                error: function (err) {
                    console.log(JSON.stringify(err));
                    if (err.status == '400') {
                        $(".response-msg-text").hide();
                        switch (err.responseJSON.ErrorCode) {
                            case 'DUPLICATE_COMPANY_NAME' :
                                $(".err-duplicate-company").show();
                                dispatchCustomEvent({getAttribute: ()=> "error"}, {pageError:{errorCode: '400', errorMessage:'Seems like this company already has an account. Re-check your company name and try again, or get in touch with your Company Admin.', errorType:'Duplicate company'}})
                                $(".modal").css("display","none");
                                break;
                            case 'EMAIL_ALREADY_EXIST' :
                                dispatchCustomEvent({getAttribute: ()=> "error"}, {pageError:{errorCode: '400', errorMessage:'Seems like an account with this email already exists. Try using another email, or get in touch with your Company Admin.', errorType:'Email already exist'}})
                                $(".err-duplicate-email").show();
                                $(".modal").css("display","none");
                                break;
                            case 'INVALID_INPUT' :
                                dispatchCustomEvent({getAttribute: ()=> "error"}, {pageError:{errorCode: '400', errorMessage:'Something went wrong.', errorType:'Something went wrong'}})
                                $(".err-invalid-input").show();
                                $(".modal").css("display","none");
                                break;
                            default:
                                dispatchCustomEvent({getAttribute: ()=> "error"}, {pageError:{errorCode: '403', errorMessage:'Oops! Seems like we’ve run into a problem. Please try again, or contact ', errorType:'Forbidden'}})
                                $(".err-default").show();
                                $(".modal").css("display","none");
                                break;
                        }
                    }
                    else {
                        $(".response-msg-text").hide();
                        dispatchCustomEvent({getAttribute: ()=> "error"}, {pageError:{errorCode: '403', errorMessage:'Oops! Seems like we’ve run into a problem. Please try again, or contact ', errorType:'Forbidden'}})
                        $(".err-default").show();
                        $(".modal").css("display","none");
                    }
                    $(".response-msg").slideDown(300);
                    $(".modal").css("display","none");
                    document.getElementById("response-error").scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        }
    }));


});
